<template>
  <div
    class="container navigate-left"
    :class="{ hasLeft: hasLeft, collapsed: isCollapse }"
  >
    <div
      class="left-wrapper nav-left-menu"
      v-show="hasLeft"
    >
      <el-scrollbar class="auto-height-scrollbar dark">
        <el-menu
          ref="leftMenu"
          :collapse="isCollapse"
          :collapse-btn="true"
          router
          wrap-scroll
          @click-collapse="onClickCollapseBtn"
        >
          <template v-for="menu in firstChildren">
            <el-submenu
              v-if="!menu.fullUrl&&menu.children && menu.children.length && menu.isShow === 0"
              :index="menu._path"
              :title="menu.name"
              :key="menu._path"
            >
              <img
                class="icon"
                slot="icon"
                :src="menu.iconInfo.path"
                :onerror="defaultIcon"
              />
              <!-- <div slot="title">
                <div class="icon"
                  :class="[menu.styleId]"></div>
                <span class="title">{{menu.name}}</span>
              </div> -->
              <el-menu-item
                v-for="sub in menu.children"
                :index="sub._path"
                :key="sub.menuId"
              >
                <!-- <img class="icon"
                  slot="icon"
                  :src="sub.iconInfo.path"
                  :onerror="defaultIcon"> -->
                {{ sub.name }}
                <!-- <span slot="title">{{sub.name}}</span> -->
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-else
              :index="menu._path"
              :key="menu._path"
            >
              <img
                class="icon"
                slot="icon"
                :src="menu.iconInfo.path"
                :onerror="defaultIcon"
              />
              {{ menu.name }}
              <!-- <div class="icon"
                :class="[menu.styleId]"></div>
              <span slot="title">{{menu.name}}</span> -->
            </el-menu-item>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
    <div class="right-wrapper">
      <common-iframe
        :srcInfo="frameSrc"
        :menuInfo="currentActiveMenu"
        frameborder="0"
        v-if="frameSrc !== ''"
      ></common-iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { autoCloseMenu } from 'utils/mixin'
import commonIframe from '../view-page/common-iframe'
export default {
  name: 'navigate-left',
  components: { commonIframe },
  props: {
    userName: String
  },
  computed: {
    ...mapGetters(['navigateSchema', 'appMenus']),
    activeMenu () {
      let _map = {
        firstMenu: null,
        secondMenu: null,
        thirdMenu: null
      }
      if (this.$route.params.first) {
        _map.firstMenu = this._getMenu(this.appMenus, this.$route.params.first)
      }
      if (_map.firstMenu) {
        if (this.$route.params.second) {
          _map.secondMenu = this._getMenu(
            _map.firstMenu.children,
            this.$route.params.second
          )
        } else if (_map.firstMenu.children.length) {
          _map.secondMenu = _map.firstMenu.children[0]
        }
      }
      if (_map.secondMenu) {
        if (this.$route.params.third) {
          _map.thirdMenu = this._getMenu(
            _map.secondMenu.children,
            this.$route.params.third
          )
        } else if (_map.secondMenu.children.length) {
          _map.thirdMenu = _map.secondMenu.children[0]
        }
      }
      return _map
    },
    tlncParams () {
      return JSON.stringify(this.$storage.get('tlncParams'))
    },
    hasLeft () {
      return this.activeMenu.firstMenu && this.activeMenu.firstMenu._hasChild
    },
    frameSrc () {
      if (this.activeMenu.thirdMenu) {
        if (this.activeMenu.thirdMenu.openType === 2) {
          window.open(this.activeMenu.thirdMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          this.currentActiveMenu = this.activeMenu.thirdMenu
          this.setIframeSrc(this.currentActiveMenu)
          return this.activeMenu.thirdMenu.fullUrl
        }
      }
      if (this.activeMenu.secondMenu) {
        if (this.activeMenu.secondMenu.openType === 2) {
          window.open(this.activeMenu.secondMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          this.currentActiveMenu = this.activeMenu.secondMenu
          this.setIframeSrc(this.currentActiveMenu)
          return this.activeMenu.secondMenu.fullUrl
        }
      }
      if (this.activeMenu.firstMenu) {
        if (this.activeMenu.firstMenu.openType === 2) {
          window.open(this.activeMenu.firstMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          this.currentActiveMenu = this.activeMenu.firstMenu
          this.setIframeSrc(this.currentActiveMenu)
          return this.activeMenu.firstMenu.fullUrl
        }
      }
      return ''
    },
    firstChildren () {
      if (this.activeMenu.firstMenu) {
        this.activeMenu.firstMenu.children.forEach(item => {
          item.children = item.fullUrl ? [] : item.children
        })
        return this.activeMenu.firstMenu.children
      } else {
        return []
      }
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`,
      isCollapse: false,
      currentActiveMenu: null
    }
  },
  watch: {
    '$route.params' () {
      this._selectMenu()
    }
  },
  methods: {
    setIframeSrc (item) {
      const tabMenusCacheMap = this.$storage.session.get(`portal-tab-menus-cache-${this.$store.state.userName}`) || {}
      if (tabMenusCacheMap[item.menuId]) {
        item.onceIframeSrc = tabMenusCacheMap[item.menuId]
      }
      this.$storage.session.remove(`portal-tab-menus-cache-${this.$store.state.userName}`)
    },
    _getMenu (arr, id) {
      let _menu = null
      if (!arr || arr.length < 0 || !id) return _menu
      arr.forEach(item => {
        if (item.menuId === id) {
          _menu = item
        }
      })
      return _menu
    },
    _selectMenu () {
      this.$nextTick(() => {
        let _selected = ''
        if (this.activeMenu.thirdMenu) {
          _selected = this.activeMenu.thirdMenu._path
        } else if (this.activeMenu.secondMenu) {
          _selected = this.activeMenu.secondMenu._path
        }
        if (this.$refs.leftMenu) {
          this.$refs.leftMenu.activeIndex = _selected
        }
      })
    },
    onClickCollapseBtn (flag) {
      if (flag) {
        this.isCollapse = flag
      } else {
        this.isCollapse = !this.isCollapse
      }
    }
  },
  mounted () {
    this._selectMenu()
    this._autoCloseMenu()
    top.window.extendScreen_closeMenu = this.onClickCollapseBtn
  },
  mixins: [autoCloseMenu]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.navigate-left.container {
  width: 100%;
  height: 100%;
  overflow: auto;
  .right-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .left-wrapper {
    overflow: auto;
  }
  &.hasLeft {
    .left-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 240px;
      .el-menu--collapse {
        /deep/ .el-tooltip {
          img {
            margin-right: 0;
            margin-left: 6px;
          }
        }
      }
      .left-menu {
        height: 100%;
        overflow: auto;
      }
    }
    .right-wrapper {
      left: 240px;
    }
    &.collapsed {
      .left-wrapper {
        width: 48px;
      }
      .right-wrapper {
        left: 48px;
      }
    }
  }
}
</style>
